module.exports = __webpack_public_path__ + "static/media/Tietosuojaseloste-UnitSpotter.948fa118.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/register/privacy/Tietosuojaseloste-UnitSpotter.pdf
// module id = 205
// module chunks = 0